import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 1DCEDC73-941F-4412-B0B7-B7042888F91A
 * name toggle-switch-off-outline
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/toggle-switch-off-outline.svg
 * tags
 */
export const ToggleSwitchOffOutlineIcon = createSvgIcon(<><path d="M17 6H7c-3.31 0-6 2.69-6 6s2.69 6 6 6h10c3.31 0 6-2.69 6-6s-2.69-6-6-6zm0 10H7c-2.21 0-4-1.79-4-4s1.79-4 4-4h10c2.21 0 4 1.79 4 4s-1.79 4-4 4zM7 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" /></>, 'ToggleSwitchOffOutlineIcon');
export default ToggleSwitchOffOutlineIcon